import { Box, List, ListItemButton, ListItemText, Typography, styled } from '@mui/material';
import { useState } from 'react';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

interface TypoProps {
  textColor: string;
}
const TypographyTheme = styled(Typography)(({ textColor }: TypoProps) => ({
  color: textColor,
  fontSize: '18px',
  textAlign: 'right',
}));
const BoxNavTheme = styled(Box)(() => ({
  borderRadius: 4,
  maxWidth: 273,
  backgroundColor: WsColors.White,
}));

const HotJobsSideNav = ({ onChange, indexCount }) => {
  const statusArray = ['All Entries', 'Web', 'Email'];
  const mapStatus = new Map();
  mapStatus.set('All Entries', indexCount);
  mapStatus.set('Web', indexCount);
  mapStatus.set('Email', indexCount);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const onChangeIndex = (index: number) => {
    setSelectedIndex(index);
  };
  return (
    <BoxNavTheme>
      <List sx={{ width: '100%', pb: 2 }} component="nav">
        <Box p={2}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.SECONDARY}>
            index
          </WsTypography>
        </Box>
        {statusArray.map((status, index) => (
          <ListItemButton
            sx={{
              background: index === selectedIndex ? WsColors.TheBlues100 : WsColors.White,
            }}
            key={index}
            onClick={() => {
              onChangeIndex(index);
              onChange(index);
            }}
          >
            <ListItemText
              primary={
                <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                  {status}
                </WsTypography>
              }
            />
            {selectedIndex === index && (
              <TypographyTheme textColor={WsColors.GenericRichBlack}>
                {mapStatus.get(status)}
              </TypographyTheme>
            )}
          </ListItemButton>
        ))}
      </List>
    </BoxNavTheme>
  );
};
export default HotJobsSideNav;
